
/**
 * State for a Promocode & voucher
 *
 * @export
 * @class State
 */
export class State {
	promo_vouchers: [{
		code: string;
		type: string;
		amount?: number;
		currencyCode?: string;
		status?: string;
		applyTo?: string;
		amountType?: string;
		actualValue?: number;
	}];
}

export const initialState: State = {
    promo_vouchers: null
};
